export default function initShowmore(params) {
    let smList = Array.from(document.querySelectorAll("[data-show-more]"))
    if (smList.length === 0) return
    smList.forEach((item) => {
        item.addEventListener('click',()=>{
            item.classList.toggle('active')
            item.parentElement.classList.toggle('more')
        })
    })
}
